import { render, staticRenderFns } from "./TomlHelp.vue?vue&type=template&id=1a6f244e&"
import script from "./TomlHelp.vue?vue&type=script&lang=js&"
export * from "./TomlHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports